var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tourwahl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tourwahl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333333,0 L2.66666667,0 C1.2,0 0,1.2 0,2.66666667 L0,21.3333333 C0,22.8 1.2,24 2.66666667,24 L21.3333333,24 C22.8,24 24,22.8 24,21.3333333 L24,2.66666667 C24,1.2 22.8,0 21.3333333,0 Z M21.3112033,21.3112033 L2.68879668,21.3112033 L2.68879668,2.68879668 L21.3112033,2.68879668 L21.3112033,21.3112033 Z M5.2780083,9.36099585 L7.96680498,9.36099585 L7.96680498,18.7219917 L5.2780083,18.7219917 L5.2780083,9.36099585 Z M10.6556017,5.37759336 L13.3443983,5.37759336 L13.3443983,18.7219917 L10.6556017,18.7219917 L10.6556017,5.37759336 Z M16.033195,13.3443983 L18.7219917,13.3443983 L18.7219917,18.7219917 L16.033195,18.7219917 L16.033195,13.3443983 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b44ee9ffc35ecd4754a300c905eb3636.svg";
export { ForwardRef as ReactComponent };